import * as ss from 'superstruct';

export const ConversionEventData = ss.record(
  ss.string(),
  ss.optional(ss.nullable(ss.union([ss.string(), ss.number(), ss.boolean()]))),
);

export type ConversionEventData = ss.Infer<typeof ConversionEventData>;
